/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Bloc "Content Accordion" (block-content-accordion.php) : ouverture/
        // fermeture au clic, classe .is-open (animation en CSS, max-height).
        // Un seul item ouvert à la fois, par bloc (.block-content-accordion__list) -
        // ouvrir un item referme automatiquement les autres du même bloc, sans
        // affecter un éventuel autre bloc accordéon présent sur la page.
        $('.block-content-accordion__trigger').on('click', function() {
          var $trigger = $(this);
          var $item = $trigger.closest('.block-content-accordion__item');
          var $list = $item.closest('.block-content-accordion__list');
          var willOpen = !$item.hasClass('is-open');

          $list.find('.block-content-accordion__item.is-open').not($item)
            .removeClass('is-open')
            .find('.block-content-accordion__trigger')
            .attr('aria-expanded', 'false');

          $item.toggleClass('is-open', willOpen);
          $trigger.attr('aria-expanded', willOpen ? 'true' : 'false');
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
